import { render } from "./ComponentPropManager.vue?vue&type=template&id=985af04a"
import script from "./ComponentPropManager.vue?vue&type=script&lang=js"
export * from "./ComponentPropManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__